// removed by extract-text-webpack-plugin
module.exports = {"strip":"OrStrip_strip---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ContactUs/OrStrip/styles.less
// module id = 1500
// module chunks = 0